<template>
  <div class="choose-address-coordinates">
    <v-dialog
      v-model="value"
      :persistent="false"
      width="1200"
      content-class="choose-address-coordinates-dialog"
      @close="close"
    >
      <v-card class="choose-address-coordinates-dialog_inner">
        <h1 class="text-center mb-3 pt-3">
          Укажите точку на карте
        </h1>
        <div class="choose-address-coordinates-map">
          <yandex-map
            :settings="settings"
            :coords="mapCenter"
            :zoom="11"
            @click="onMapClick"
          >
            <map-polygon
              v-for="p in polygons"
              :key="`polygon-${p.id}`"
              :polygon="p"
              :show-balloon="false"
              @click="onMapClick"
            />
            <ymap-marker
              v-if="coords"
              :coords="coords"
              :marker-id="1"
              marker-type="placemark"
              :icon="markerIcon"
            />
          </yandex-map>
        </div>
        <v-card-actions class="d-flex j-end">
          <v-btn
            depressed
            large
            @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
            color="success"
            depressed
            large
            :disabled="!coords"
            @click="save"
          >
            ОК
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import yandexMap, { loadYmap, ymapMarker } from 'vue-yandex-maps'
  import _ from 'lodash'
  import MapPolygon from '@/components/geo/couriers-map/MapPolygon.vue'

  export default {
    name: 'ChooseAddressCoordinatesDialog',
    components: {
      MapPolygon,
      yandexMap,
      ymapMarker,
    },
    emits: ['close', 'save'],
    data () {
      return {
        coords: null,
      }
    },
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      center: {
        type: Array,
        default: null,
      },
    },
    computed: {
      ...mapState({
        apiKey: state => state.app.yandexMapsYandexMapsApiKey,
      }),
      ...mapGetters({
        polygons: 'polygons/getPolygons',
      }),
      mapCenter () {
        return this.coords || this.center || [55.762832, 37.611520]
      },
      settings () {
        return {
          apiKey: this.apiKey,
          lang: 'ru_RU',
          coordorder: 'latlong',
          version: '2.1',
        }
      },
      markerIcon () {
        return {
          color: 'darkOrange',
        }
      },
    },
    methods: {
      onMapClick (event) {
        console.log('onMapClick', event.get('coords'))
        this.coords = event.get('coords')
      },
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },
      save () {
        this.$emit('save', this.coords)
        this.coords = null
        this.close()
      },
      async loadPolygons () {
        await this.$store.dispatch('polygons/getPolygonsFromApi')
      },
    },
    async mounted () {
      // await loadYmap({ ...this.settings, debug: true })
      // здесь доступна переменная ymaps
      // console.log('ymaps', ymaps)
      // console.log(this.settings)
    },
    created () {
      if (_.isEmpty(this.polygons)) {
        this.loadPolygons()
      }
    },
  }
</script>

<style scoped lang="less">
.choose-address-coordinates {

  &-dialog_inner {
    //padding: 0;
  }

  &-map {
    position: relative;
    height: 75vh;
    margin: 0 30px;
    .ymap-container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
